import { AutogenLayoutEDIOrderProfileQuickInfo } from "./autogen/AutogenLayoutEDIOrderProfileQuickInfo";

export class EDIOrderProfileQuickInfo extends AutogenLayoutEDIOrderProfileQuickInfo {

}
